export const renameText = {
  en: {
    heading: 'Display name', save: 'Save', saving: 'Saving…', saved: 'Saved',
    taken: 'Another account already uses that name.',
    empty: 'Please enter a name.',
    failed: 'Could not save that. Please try again.',
    note: 'Your reading history follows your account, so it stays with you. The old name keeps working at sign-in.',
  },
  es: {
    heading: 'Nombre visible', save: 'Guardar', saving: 'Guardando…', saved: 'Guardado',
    taken: 'Otra cuenta ya usa ese nombre.',
    empty: 'Por favor ingresa un nombre.',
    failed: 'No se pudo guardar. Inténtalo de nuevo.',
    note: 'Tu historial sigue a tu cuenta, así que se mantiene. El nombre anterior seguirá funcionando al entrar.',
  },
  zh: {
    heading: '顯示名稱', save: '儲存', saving: '儲存中…', saved: '已儲存',
    taken: '這個名稱已被其他帳號使用。',
    empty: '請輸入名稱。',
    failed: '無法儲存，請再試一次。',
    note: '閱讀記錄跟著帳號走，不會遺失。舊名稱仍可用來登入。',
  },
  sc: {
    heading: '显示名称', save: '保存', saving: '保存中…', saved: '已保存',
    taken: '这个名称已被其他帐号使用。',
    empty: '请输入名称。',
    failed: '无法保存，请再试一次。',
    note: '阅读记录跟着帐号走，不会丢失。旧名称仍可用来登录。',
  },
};
